import React from "react";
import PropTypes from "prop-types";
import { withStyles, Typography, Box, List, ListItem } from "@material-ui/core";

const borderWidth = 1;
const borderColor = '#b8daff';
const borderRadius = 8;
const margin = 10;
const primaryColor = '#007bff';
const secondaryColor = 'blue';


const styles = (theme) => ({
  wrapper: {
    border: `${borderWidth}px solid ${borderColor}`,
  },
  greyed: {
    border: `${borderWidth}px solid rgba(0, 0, 0, 0.23)`,
  },

  card: {
    marginTop: margin,
    border: `1px solid ${borderColor}`,
    borderRadius: borderRadius * 2,
    marginBottom: margin
  },

  cardNoBorder: {
    marginTop: margin,
    borderRadius: borderRadius * 2,
    marginBottom: margin
  },

  title: {
    color: primaryColor,
  },
  subTitle: {
     color: secondaryColor,
  },
});

// <ListItemText  className={classes.title} primary={title} secondary={subTitle} />

function KCard(props) {
  const { title, subTitle, classes, children, noBorder } = props;

  const className = noBorder === true ? classes.cardNoBorder : classes.card;

  return (
    <div className={className}>
      <Box mb={0}>
        {title || subTitle ? (
          <List dense>
            {title && (
              <ListItem>
                <Typography variant={"h6"} className={classes.title}>
                  {title}
                </Typography>
              </ListItem>
            )}
            {subTitle && (
              <ListItem>
                <Typography className={classes.subTitle}>{subTitle}</Typography>
              </ListItem>
            )}
          </List>
        ) : (
          ""
        )}
        <Box mt={2}>
            {children}
        </Box>
      </Box>
    </div>
  );
}

KCard.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object,
  disableVerticalPadding: PropTypes.bool,
  disableBorderRadius: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.array,
  ]),
  variant: PropTypes.string,
  noBorder: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(KCard);
